// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { getContentFormContainer } =
  require("../../manage/methods/ContentFormUtils").default
const { RICHTEXT, EMBED, LISTED } = require("./ManageReadingConfig").default

export const rt = {
  icon: "file-text",
  title: "Write a new document",
  prompt: "Add headlines, images, and more.",
  form: getContentFormContainer(RICHTEXT)
}
export const embed = {
  icon: "file-code",
  title: "Embed a reading",
  prompt: "Embed an article from another site.",
  form: getContentFormContainer(EMBED)
}
export const listed = {
  icon: "share",
  title: "Reference external source",
  prompt: "Add instructions to read a book, external website,...",
  form: getContentFormContainer(LISTED)
}
